// Resolves an approval slot only through its validated command alias. A
// superseded cause means a new user message retired the request, drawn as
// expired rather than as a denial the user chose.
import { z } from 'zod';

import { defineCompoundMember } from '@apps/web/features/phoebe_chat_v3/registry/types';

const toolApprovalDeniedPayloadSchema = z
    .object({
        command_id: z.uuid(),
        // Any unknown cause reads as a plain denial, so a future value never
        // leaves the card stuck pending.
        cause: z.string().nullable().optional().default(null),
    })
    .strip();

export const toolApprovalDeniedDefinitions = {
    tool_approval_denied: defineCompoundMember('tool_approval_denied', {
        disposition: 'compound_member',
        schema: toolApprovalDeniedPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
        slotMember: {
            slot: 'approval',
            terminal: true,
            keys(payload) {
                return [{ kind: 'command_id', value: payload.command_id }];
            },
            fragment(payload) {
                return {
                    kind: 'approval_resolved',
                    commandId: payload.command_id,
                    decision:
                        payload.cause === 'superseded_by_message'
                            ? 'expired'
                            : 'denied',
                };
            },
        },
    }),
} as const;

export const toolApprovalDeniedContractFixtures = {
    valid: {
        command_id: '0198a846-739e-7a2f-a152-66a77cc11111',
        cause: 'superseded_by_message',
    },
    malformed: { command_id: 'not-a-uuid' },
} as const;
